import Swal from "sweetalert2";
import { Field, Form } from 'react-final-form';
import React, { useState, useEffect } from 'react';
import { Button } from '@/shared/components/Button';
import TimetableIcon from 'mdi-react/TimetableIcon';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import renderSelectField from '@/shared/components/form/Select';
import renderComponentField from '@/shared/components/form/FormField';
import DateTimePicker from "@/shared/components/form/date-pickers/DateTimePicker";
import { Card, CardBody, CardTitleWrap, CardTitle } from '@/shared/components/Card';
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField, FormGroupLabel, FormGroupIcon } from '@/shared/components/form/FormElements';

const required = value => value ? undefined : 'Required';

const NewMission = (props) => {
    const [collectionsList, setCollectionsList] = useState();
    const [countriesList, setCountriesList] = useState();
    const [statesList, setStatesList] = useState([]);
    const [citiesList, setCitiesList] = useState([]);

    const GetCountries = () => {
        AdminInterface.instance.getCountries().then((response) => {
            setCountriesList(response.data);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting countries list.',
            });
        })
    }

    const handleCountryChange = (value, form) => {
        setStatesList([]);
        setCitiesList([]);
        form.change('state', { value: undefined, label: undefined });
        form.change('city', { value: undefined, label: undefined });
        AdminInterface.instance.getStates(value.value).then((response) => {
            setStatesList(response.data);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting states list.',
            });
        })
        return value;
    }

    const handleStateChange = (state, form) => {
        setCitiesList([]);
        form.change('city', { value: undefined, label: undefined });
        let country = form.getFieldState('country').value.value;
        AdminInterface.instance.getCities(country, state.value).then((response) => {
            setCitiesList(response.data);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting cities list.',
            });
        })
        return state;
    }

    const GetCollections = () => {
        AdminInterface.instance.getCollections().then((response) => {
            setCollectionsList(response.data);
            GetCountries();
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: 'Error in getting collections.',
            });
        }).finally(() => {
            props.setListRequiresReload(false);
        });
    }

    useEffect(() => {
        GetCollections();
    }, []);

    const submitNewMission = (mission) => {
        let data = {}
        data.name = mission.name;
        data.collection_id = mission.collection_id.value;
        data.start_datetime = mission.start_datetime;
        data.end_datetime = mission.end_datetime;
        data.country = mission.country.label;
        data.state = mission.state.label;
        data.city = mission.city?.value;
        AdminInterface.instance.createMission(data).then(() => {
            withReactContent(Swal).fire({
                icon: 'success',
                title: 'Success',
                html: 'New mission is created.',
            });
            props.setListRequiresReload(true);
        }).catch((error) => {
            withReactContent(Swal).fire({
                icon: 'error',
                title: 'Error',
                html: [error.response?.data?.detail.map((detail) => detail.msg)],
            });
        });
    }

    const resetForm = (form) => {
        form.reset();
        form.change('start_datetime', new Date());
        form.change('end_datetime', new Date());
    }

    return (
        <Card>
            <CardBody>
                <CardTitleWrap>
                    <CardTitle>New Mission</CardTitle>
                </CardTitleWrap>
                {countriesList && <Form onSubmit={submitNewMission}>
                    {({ handleSubmit, form }) => (
                        <FormContainer horizontal onSubmit={handleSubmit}>
                            <FormGroup>
                                <FormGroupLabel>Name</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="name" component={renderComponentField} placeholder="Name" validate={required} />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Collection</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="collection_id" component={renderSelectField} validate={required} placeholder="Collection"
                                        options={collectionsList.map(function (collection) {
                                            return { value: collection.id, label: collection.name }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Start Datetime</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="start_datetime" component={DateTimePicker} validate={required} />
                                    <FormGroupIcon><TimetableIcon/></FormGroupIcon>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>End Datetime</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="end_datetime" component={DateTimePicker} validate={required} />
                                    <FormGroupIcon><TimetableIcon/></FormGroupIcon>
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>Country</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="country" component={renderSelectField} validate={required} placeholder="Country" parse={(value) => handleCountryChange(value, form)}
                                        options={countriesList.map(function (country) {
                                            return { value: country['id'], label: country['name'] }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>State/Province</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="state" component={renderSelectField} validate={required} placeholder="State/Province" parse={(value) => handleStateChange(value, form)}
                                        options={statesList.map(function (state) {
                                            return { value: state['id'], label: state['name'] }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormGroup>
                                <FormGroupLabel>City</FormGroupLabel>
                                <FormGroupField>
                                    <Field name="city" component={renderSelectField} placeholder="City"
                                        options={citiesList.map(function (city) {
                                            return { value: city['name'], label: city['name'] }
                                        })}
                                    />
                                </FormGroupField>
                            </FormGroup>
                            <FormButtonToolbar>
                                <Button variant="primary" type="submit">Submit</Button>
                                <Button variant="secondary" type="button" onClick={() => resetForm(form)}>
                                    Cancel
                                </Button>
                            </FormButtonToolbar>
                        </FormContainer>
                    )}
                </Form>}
            </CardBody>
        </Card>
    );
};

export default NewMission;